import { render, staticRenderFns } from "./Tiedostopankki.vue?vue&type=template&id=6b361ba3&scoped=true"
import script from "./Tiedostopankki.vue?vue&type=script&lang=js"
export * from "./Tiedostopankki.vue?vue&type=script&lang=js"
import style0 from "./Tiedostopankki.vue?vue&type=style&index=0&id=6b361ba3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b361ba3",
  null
  
)

export default component.exports